import { apiClient } from './apiClient';

// fields that are editable from the API but generally 
// should not be updated from the admin UI
const blackListedFields = [
  'chef_email_sent_at',
  'chef_email_recipients',
  'client_email_sent_at',
  'client_email_recipients'
];
class ServiceAPI {
  sendService(id, params = {}) {
    return apiClient.request(`/services/${id}/send`, 'POST', true, params);
  }

  searchServices(params = {}) {
    return apiClient.request(`/services/search`, 'POST', true, params);
  }

  exportServices(params = {}, filename = 'services.csv') {
    return apiClient.download(
      filename,
      `/services/export`,
      'GET',
      true,
      params
    );
  }

  getService(id) {
    return apiClient.request(`/services/${id}`, 'GET', true);
  }

  createService(service) {
    service = this.blackListServiceFields(service)
    service = this.prepareServiceForSubmit(service)
    return apiClient.request(`/services`, 'POST', true, service);
  }

  batchCreateServices(service) {
    service = this.blackListServiceFields(service)
    service = this.prepareServiceForSubmit(service)
    return apiClient.request(`/services/batch_create`, 'POST', true, service);
  }

  updateService(service) {
    service = this.blackListServiceFields(service)
    return apiClient.request(`/services/${service.id}`, 'PUT', true, service);
  }

  skipService(id, skipped_reason) {
    return apiClient.request(`/services/${id}/skip`, 'PATCH', true, {
      id,
      skipped_reason
    });
  }

  unSkipService(id) {
    return apiClient.request(`/services/${id}/unskip`, 'PATCH', true, {
      id
    });
  }

  updateMenuSelections(id, service, returnEmpty = false) {
    service = this.blackListServiceFields(service)
    return apiClient.request(`/services/${id}`, 'PUT', true, { ...service, return_empty: returnEmpty });
  }

  deleteService(id) {
    return apiClient.request(`/services/${id}`, 'DELETE', true);
  }

  getGroceryList(id) {
    return apiClient.request(`/services/${id}/grocery_list`, 'GET', true);
  }

  updateGroceryList(groceryList) {
    return apiClient.request(
      `/grocery_lists/${groceryList.id}`,
      'PUT',
      true,
      groceryList
    );
  }

  sendChefInvitation(serviceId, chefId, emailBody) {
    const body = {
      email_body: emailBody
    };
    return apiClient.request(
      `/services/${serviceId}/chefs/${chefId}/notify`,
      'POST',
      true,
      body
    );
  }

  sendChefInvitationSms(serviceId, chefId) {
    const body = {
      use_sms: true
    };
    return apiClient.request(
      `/services/${serviceId}/chefs/${chefId}/notify`,
      'POST',
      true,
      body
    );
  }

  downloadChefMaterials(id, filename = 'materials.pdf') {
    return apiClient.download(
      filename,
      `/services/${id}/download`,
      'GET',
      true
    );
  }

  duplicateDish(serviceID, dishID) {
    return apiClient.request(
      `/services/${serviceID}/duplicate/${dishID}`,
      'POST',
      true
    );
  }

  getServiceDistricts() {
    return apiClient.request(`/service_districts`, 'GET', true);
  }

  blackListServiceFields(service) {
    blackListedFields.forEach(field => {
      delete service[field]
    })
    return service
  }

  prepareServiceForSubmit(service) {
    if (Array.isArray(service.additional_dates)) {
      service.additional_dates = service.additional_dates.map(d => 
        // converts local date to UTC date
        new Date(d.getTime() - Math.abs(d.getTimezoneOffset()*60000))
      )
    }
    return service
  }

  sendSmsReminder(id) {
    return apiClient.request(`/services/${id}/reminder_sms`, 'POST', true);
  }

  getChefConflicts(chef_ids, start_time, end_time, service_id = null) {
    const body = {
      chef_ids, start_time, end_time, service_id
    };
    return apiClient.request(`/services/chef_validation`, 'POST', true, body);
  }

  skipServiceWithToken(token) {
    return apiClient.request(
      `/services/client_skip/${token}`,
      'PATCH',
      true
    );
  }
}
export const serviceAPI = new ServiceAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/serviceAPI.js